'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slick-carousel');

var slickSettings = {
  centerMode: false,
  arrows: true,
  rows: 0,
  slidesToShow: 5,
  slidesToScroll: 1,
  swipeToSlide: true,
  prevArrow: '[data-explore-by-series-slider-prev]',
  nextArrow: '[data-explore-by-series-slider-next]',
  responsive: [{
    breakpoint: 1300,
    settings: {
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      draggable: true,
      swipeToSlide: true,
      rows: 0,
      arrows: true
    }
  }, {
    breakpoint: 991,
    settings: {
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      draggable: true,
      swipeToSlide: true,
      rows: 0,
      arrows: true
    }
  }, {
    breakpoint: 768,
    settings: {
      centerMode: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      draggable: true,
      swipeToSlide: true,
      rows: 0,
      arrows: true
    }
  }, {
    breakpoint: 600,
    settings: {
      centerMode: true,
      slidesToShow: 1,
      draggable: true,
      swipeToSlide: true,
      rows: 0,
      arrows: true
    }
  }]
}; // could be refactored into `components/Sliders`


var bindActions = function bindActions() {
  if ($('.js-explore-by-series-slider:not(.slick-initialized)').length) {
    $('.js-explore-by-series-slider').each(function (index, element) {
      $(element).slick(slickSettings);
    });
  }
};

var init = function init() {
  bindActions();
};

exports.default = {
  init: init
};